// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2EkRi","label":"Category_label__k2_zo","content":"Category_content__3rXL2","header":"Category_header__2UkqR","location":"Category_location__3A1tl"};